import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import cn from './../../lib/bem/index';
import ico_soles from './../../assets/svg/ico_soles.svg';
import ico_dolares from './../../assets/svg/ico_dolares.svg';
import { removeFormatNumber } from './../../lib/utils/index';
import { updateMoneda, updateMonto, postCotizarSimulacion, updateMontosResp, postCaptcha } from './../../redux/reducers/simuladorFVGSlice';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import './monedaSelect_component.scss';

const MonedaSelectComponent = () => {

    const classes = cn("monedaSelectComponent");
    const dispatch = useDispatch();

    const { executeRecaptcha } = useGoogleReCaptcha();

    const simuladorFVG    = useSelector((state) => state.rootReducers.simuladorFVG);

    const onChangeMoneda = async (value) => {
	const token = await executeRecaptcha('ecowebapp');


        dispatch(updateMoneda({
            'moneda' : value
        }));

        var param = simuladorFVG.parametros.filter( item => item.plazo === parseInt(simuladorFVG.plazo) && item.moneda === value );
        var montoMinimo = param.length > 0 ? param[0].montoMinimo : 0;
        var montoMaximo = param.length > 0 ? param[0].montoMaximo : 0;

        var monto   = simuladorFVG.monto === "" ? 0 : parseFloat(removeFormatNumber(simuladorFVG.monto));

        if( monto >= parseFloat(montoMinimo) && monto <= parseFloat(montoMaximo) && monto !== 0 ){
            
            if(process.env.REACT_APP_ACTIVE_VALIDATION_RECAPTCHA === 'true'){

                dispatch(postCaptcha(
                    token
                )).then((resp) => { 
                    if(resp.payload.datos.esValido){
                        dispatch(postCotizarSimulacion({
                            "idSimulacion"  : simuladorFVG.idSimulacion,
                            "moneda"    : value,
                            "monto"     : monto,
                            "plazo"     : simuladorFVG.plazo
                        }));
                    }
                });
            } else {
                dispatch(postCotizarSimulacion({
                    "idSimulacion"  : simuladorFVG.idSimulacion,
                    "moneda"    : value,
                    "monto"     : monto,
                    "plazo"     : simuladorFVG.plazo
                }));
            }

        } else {
            dispatch(updateMonto({
                "monto"     : '',
            }));
            dispatch(updateMontosResp());
        }
    }

    return (
        <div className={classes()}>
            <div>
                <p className={classes('monedaSelect_text')}>Moneda</p>
            </div>
            <div className={classes('monedaRadioSelect')}>
                <div>
                    <input className={classes('monedaSelectinputRd')} type="radio" id={'moneda_1'} name="rbtMoneda" value={'S'} onChange={() => onChangeMoneda('S')} checked={simuladorFVG.moneda === 'S'}/>
                    <label className={classes('monedaSelectinputlabel')} htmlFor={'moneda_1'}>
                        <img src={ico_soles} alt={'ico_soles'}/><p>Soles</p>
                    </label>
                </div>
                <div>
                    <input className={classes('monedaSelectinputRd')} type="radio" id={'moneda_2'} name="rbtMoneda" value={'D'} onChange={() => onChangeMoneda('D')} checked={simuladorFVG.moneda === 'D'}/>
                    <label className={classes('monedaSelectinputlabel')} htmlFor={'moneda_2'}>
                        <img src={ico_dolares} alt={'ico_dolares'}/><p>Dólares</p>
                    </label>
                </div>
            </div>
        </div>
    );
};

export default MonedaSelectComponent;